import { ProductRepository } from '../repositories/ProductRepository';
import { ViewController } from '@estee/elc-service';
import { Product } from '../domain/entities/Product';
import { observable, computed, action } from 'mobx';
import { Sku } from '../domain/entities/Sku';
import { QueryFragments } from '~api/QueryFragments';
import { IFeatures } from '~constants/Features';
import { IProductBasicInfoConfig } from 'src/exported/product-basic-info/ProductBasicInfo';

export interface IProductBasicInfoViewControllerData {
    selectedSku?: Sku;
}

export class ProductBasicInfoViewController extends ViewController {
    private productRepository: ProductRepository;

    @observable public product: Product;
    @observable public selectedSku: Sku;
    @observable public selectedSkuId: string;
    @observable private queryFragments: QueryFragments;
    @observable public isLoaded: boolean = false;

    constructor(productRepository: ProductRepository, queryFragments: QueryFragments) {
        super();
        this.productRepository = productRepository;
        this.queryFragments = queryFragments;
    }

    @computed
    public get data(): IProductBasicInfoViewControllerData {
        return {
            selectedSku: this.selectedSku
        };
    }

    @action
    public loaded = async (config: IProductBasicInfoConfig) => {
        const { skuId, features } = config;
        this.selectedSkuId = skuId;
        this.queryFragments.setFeatures(<IFeatures>features);

        this.product = await this.productRepository.getProductBySkuId(skuId, {
            queryFragments: this.queryFragments.queryFragments
        });
        this.setSelectedSku();

        if (this.selectedSku) {
            this.isLoaded = true;
        }
    };

    @action
    private setSelectedSku() {
        this.selectedSku = this.product.skus.find(
            ({ skuId }: Sku) => skuId === this.selectedSkuId
        ) as Sku;
    }
}
